import React from 'react';
import Hero from '../Hero/Hero';
import Card from '../Card/Card';
import Stories from '../Stories/Stories';
import Stats from '../Stats/Stats'

export default function Home() {

  return (
    <div>
        <Hero />
        <Card />
        <Stats />
        <Stories />
</div>
 )
}